import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import LogInButtons from 'flarum/forum/components/LogInButtons';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';
app.initializers.add('fof-passport', () => {
  override('flarum/forum/components/LogInModal', 'oncreate', function () {
    window.location.href = app.forum.attribute('baseUrl') + '/auth/passport';
    throw new Error('Stop execution');
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (items.has('signUp')) {
      items.remove('signUp');
    }
    if (items.has('logIn')) {
      items.setContent('logIn', Button.component({
        className: 'Button Button--link',
        onclick() {
          window.location.href = app.forum.attribute('baseUrl') + '/auth/passport';
        }
      }, app.translator.trans('core.forum.header.log_in_link')));
    }
  });
  extend(LogInButtons.prototype, 'items', function (items) {
    items.add('fof-passport', Button.component({
      className: 'Button Button--passport',
      icon: app.forum.attribute('fof-passport.loginIcon'),
      onclick() {
        window.location.href = app.forum.attribute('baseUrl') + '/auth/passport';
      }
    }, app.forum.attribute('fof-passport.loginTitle')));
  });
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    if (app.forum.attribute('fof-passport.disablePasswordChange')) {
      items.remove('changePassword');
    }
    if (app.forum.attribute('fof-passport.disableEmailChange')) {
      items.remove('changeEmail');
    }
  });
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    if (items.has('account') && items.get('account').children.length === 0) {
      items.remove('account');
    }
  });
});